import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudDialogModule } from '@freud-ds/web-components';
import { FreudAvatarModule } from '@freud-ds/web-components';
import { FreudDynamicDialogModule } from '@freud-ds/web-components';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { PromptuaryComplianceSection } from './promptuary-compliance-section';

@NgModule({
	declarations: [PromptuaryComplianceSection],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudDialogModule,
		FreudDynamicDialogModule,
		FreudAvatarModule,
		FreudTypographyModule,
	],
	exports: [PromptuaryComplianceSection],
	providers: [],
})
export class PromptuaryComplianceSectionModule {}
